import { mapGetters } from 'vuex';
import { routeToProduct } from '@/helpers';
import { MEDIA } from '@/helpers/variables';

import ImageCard from '@/components/@general/ImageCard/index.vue';
import StarRating from 'vue-star-rating';
import IconVerify from '@/components/icons/IconVerify.vue';
import IconShareInstagram from '@/components/icons/IconShareInstagram.vue';
import IconShareFacebook from '@/components/icons/IconShareFacebook.vue';

export default {
  name: 'BlockReviewCard',
  components: {
    IconShareFacebook,
    IconShareInstagram,
    IconVerify,
    ImageCard,
    StarRating
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      MEDIA
    };
  },

  created() {},
  mounted() {},
  computed: {
    ...mapGetters({
      appSize: 'app/size'
    })
  },

  methods: {
    routeToProduct
  }
};
